import { Avatar, AVATAR_HEIGHT_24 } from '../../../../Avatar'
import { EntityStatus } from '../../../../Entity'
import { getListingPortalLabel } from '../../../../RentalPortalListing'
import Text from '../../../../Text'
import { getPortalAvatarProps } from '../../../RentalPortal.utils'
import { INTEGRATION_CONNECTION_STATUSES } from '../../RentalPortalIntegrations.constants'
import { getIntegrationConnectionStatus } from '../../RentalPortalIntegrations.utils'
import {
  QA_NAME_INTEGRATIONS_PANEL_STATUS,
  QA_NAME_INTEGRATIONS_PANEL_TITLE,
} from '../RentalPortalIntegrationsPanel.constants'

import * as styles from './IntegrationsPanelHeader.module.css'

function IntegrationsPanelHeader({ CloseButton, connection, onClose }) {
  return (
    <div className={styles.IntegrationsPanelHeader}>
      <Avatar
        {...getPortalAvatarProps(connection.portal)}
        className={styles.logo}
        size={AVATAR_HEIGHT_24}
      />
      <span className={styles.headline}>
        <Text
          className={styles.title}
          qaName={QA_NAME_INTEGRATIONS_PANEL_TITLE}
        >
          {getListingPortalLabel(connection.portal)}
        </Text>
        <EntityStatus
          id={getIntegrationConnectionStatus(connection)}
          statuses={INTEGRATION_CONNECTION_STATUSES}
          textQaName={QA_NAME_INTEGRATIONS_PANEL_STATUS}
        />
      </span>
      <CloseButton onClose={onClose} />
    </div>
  )
}

export default IntegrationsPanelHeader
